import { render } from "./ActivateWarrantyPlanSelector.vue?vue&type=template&id=489d4e63&scoped=true&ts=true"
import script from "./ActivateWarrantyPlanSelector.vue?vue&type=script&lang=ts"
export * from "./ActivateWarrantyPlanSelector.vue?vue&type=script&lang=ts"

import "./ActivateWarrantyPlanSelector.vue?vue&type=style&index=0&id=489d4e63&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489d4e63"]])

export default __exports__